import { useMemo } from "react";

export const useDeepMemo = <T>(value: T) => {
  const memoizedValue = useMemo(() => value, [JSON.stringify(value)]);
  return memoizedValue;
};
